//Allow to extend any variable if any.

export interface AnalyticTrackingBasePropertiesObj {
  access: Object;
  locationId?: string[];
  itemGroup?: string;
  pageName: string;
  retailerDataFor?: string;
  section: string;
  subsection: string;
  topFiltersLoaded?: Object;
  globalFilterAppliedOnPV?: Object;
}

export enum TrackingGeneralProp {
  ACCESS_TRACKING_PROP = 'Retail Insights',
  SECTION_TRACKING_PROP = 'Retail Intelligence',
}

export enum ElementType {
  CARD = 'Card',
  TABLE = 'Table',
  CHART = 'Chart',
  LINE_CHART = 'Line Chart',
  BAR_CHART = 'Double Bar Chart',
  COMBINED_CHART = 'Combined Chart',
  STACKED_CHART = 'Stacked Chart',
  BUBBLE_CHART = 'Bubble Chart',
  DONUT_CHART = 'Donut Chart',
  BUTTERFLY_CHART = 'Butterfly Chart',
  TILES = 'Tiles',
}

export enum ErrorType {
  NONE = 'None',
}

export enum FilterName {
  GLOBAL_FILTER = 'Global Filter',
}

export enum FilterType {
  PLATFORM = 'Platform',
  SELECTORS = 'Selectors',
}
